/**
 * Translations.
 */
export default {
  ACTION: {},
  ERROR: {
    DELETE_TWITCH: 'Cancelar integração Twitch',
    ERROR: 'Erro',
    FETCH_DATA: 'Obter dados'
  },
  HEADER: {
    DATE: 'Data',
    MESSAGE: 'Mensagem',
    NAME: 'Nome',
    ORDER_CODE: 'Cod. Enc.',
    ORDER_VALUE: 'Valor'
  },
  LABEL: {
    ACTIVE_SINCE: 'Ativo desde',
    INTEGRATIONS: 'Integrações',
    TWITCH: 'Twitch',
    TWITCH_AUTH: 'Autorizar Twitch',
    TWITCH_AUTHORIZED_INFORMATION:
      'A Prozis tem autorização para gerar alertas na twitch durante as streams.',
    TWITCH_INFORMATION:
      'A Prozis irá pedir autorização para gerar alertas na twitch durante as streams.',
    TWITCH_INTEGRATION: 'Integração Twitch'
  },
  SENTENCE: {},
  SUCCESS: {
    DELETE_TWITCH: 'Integração Twitch cancelada',
    SUCCESS: 'Sucesso'
  },
  TOOLTIP: {
    ORDER_CODE: 'Código da encomenda'
  }
};
